import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const Testimonials: React.FC = () => {
  const testimonials = [{
    name: 'Camila R.',
    text: 'Increíble el cambio. Desde que lanzamos la web, las consultas por WhatsApp se multiplicaron. El diseño es súper profesional.'
  }, {
    name: 'Martín L.',
    text: 'Rápidos, profesionales y entendieron perfecto lo que mi negocio necesitaba. La página quedó espectacular y carga rapidísimo.'
  }, {
    name: 'Sofía M.',
    text: 'Dudaba si necesitaba una web, pero fue la mejor inversión. Ahora mis clientes ven todos mis servicios ordenados y confían más.'
  }, {
    name: 'Valeria G.',
    text: 'El diseño superó mis expectativas. Me encantó que esté tan bien adaptada para celulares, que es de donde entran todos mis clientes.'
  }, {
    name: 'Daniel M.',
    text: 'Excelente atención y resultado final. La web transmite exactamente la seriedad que quería para mi empresa.'
  }];
  return <section className="py-24 relative z-10 overflow-hidden" data-id="element-174">
      <div className="max-w-7xl mx-auto px-6" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-bold" data-id="element-177">
            Lo que dicen nuestros clientes
          </h2>
        </motion.div>

        {/* Marquee effect for testimonials */}
        <div className="relative flex overflow-x-hidden gap-6 py-4" data-id="element-178">
          <motion.div className="flex gap-6 whitespace-nowrap" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 40,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-179">
            {/* Double the array for seamless looping */}
            {[...testimonials, ...testimonials].map((testimonial, index) => <div key={index} className="w-[350px] md:w-[400px] flex-shrink-0 bg-dark-surface border border-white/10 rounded-2xl p-8 whitespace-normal" data-id="element-180">
                <div className="flex gap-1 mb-4 text-neon-blue" data-id="element-181">
                  {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-182" />)}
                </div>
                <p className="text-silver mb-6 italic" data-id="element-183">"{testimonial.text}"</p>
                <div className="flex items-center gap-4" data-id="element-184">
                  <div className="w-12 h-12 rounded-full bg-dark-bg border border-neon-blue/50 flex items-center justify-center font-display font-bold text-lg text-white shadow-[0_0_10px_rgba(0,207,255,0.2)]" data-id="element-185">
                    {testimonial.name.charAt(0)}
                  </div>
                  <span className="font-bold text-white" data-id="element-186">
                    {testimonial.name}
                  </span>
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
};